import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
const URI = ApiEndpoint + 'configuration/';

const EditTipoPlataforma = ({ idTipoPlataforma, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tipoPlataforma, setTipoPlataforma] = useState({
    plataforma: ''
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getTipoPlataforma = async () => {
    setTipoPlataforma(null);

    httpClient(
      'GET',
      URI + 'tiposplataforma/' + idTipoPlataforma,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setValue('plataforma', response.data.plataforma);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const onSubmit = data => {
    console.log(data);

    if (idTipoPlataforma > 0) {
      httpClient(
        'put',
        URI + 'tiposplataforma/' + idTipoPlataforma,
        {
          plataforma: data.plataforma
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'tiposplataforma',
        {
          plataforma: data.plataforma
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  useEffect(() => {
    if (idTipoPlataforma > 0) getTipoPlataforma();
  }, []);
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Tipo de Plataforma</Form.Label>
                <FormControl
                  {...register('plataforma', {
                    required: 'El tipo de plataforma es requerido'
                  })}
                  type="text"
                  defaultValue={tipoPlataforma?.plataforma}
                  isInvalid={!!errors.plataforma}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.plataforma?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

EditTipoPlataforma.propTypes = {
  idTipoPlataforma: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};

export default EditTipoPlataforma;
